import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { FileInfoType, processSupportedExtensions, processSupportedVideoExtensions, processSupportedImageExtensions, processSupportedAudioExtensions, processSupportedDocExtensions } from '@schoolbelle/api/file';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class LetterWriteFileListPreviewComponent implements OnInit {
  @Input() file:FileInfoType|File;

  get type () {
    return this.file.type.split('/')[0];
  }
  get thumbnail () {
    if (this.file instanceof Blob) {
      return;
    } else {
      return this.file.thumbnail || this.file.downsampled || this.file.url;
    }
  }
  objectURL:string;
  get preview () {
    const extension = this.file.name && this.file.name.split('.').pop().toLowerCase();
    if (!this.objectURL && this.file instanceof Blob && this.file.type.match(/^(image|video)/) && processSupportedExtensions.includes(extension)) {
      this.objectURL = URL.createObjectURL(this.file);
    }
    if (processSupportedExtensions.includes(extension)) {
      if (processSupportedVideoExtensions.includes(extension)) {
        if (this.file.type.match(/(video\/mp4)/i)) return this.sanitizer.bypassSecurityTrustResourceUrl(this.objectURL);
        else 'assets/images/default-video.png';
      }
      else if (processSupportedImageExtensions.includes(extension)) {
        if (this.file.type.match(/(image\/jpeg|image\/png|image\/bmp)/i)) return this.sanitizer.bypassSecurityTrustUrl(this.objectURL);
        else return 'assets/images/default-image.png'
      }  
      else if (processSupportedDocExtensions.includes(extension)) {
        return 'assets/images/default-doc.png'
      }
      else if (processSupportedAudioExtensions.includes(extension)) {
        return 'assets/images/default-audio.png'
      }
    }
    return '';
  }
  constructor(
    protected sanitizer:DomSanitizer,
  ) { }
  ngOnInit() {
  }
}
